

import type { AppProps } from 'next/app';
import { SessionProvider } from "next-auth/react";
import { UserContextProvider } from '../context/UserContext';
import getConfig from 'next/config';
import AuthorizedApolloProvider from '../apollo-client/apollo-client'

const { publicRuntimeConfig } = getConfig();
function MyApp({ Component, pageProps }: AppProps) {
  return (
    <SessionProvider
      session={pageProps.session}
      basePath={`${publicRuntimeConfig.basePath || ''}/api/auth`}
      refetchInterval={1 * 15}
      refetchOnWindowFocus={true}>
      <link href='https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700;800;900&family=Open+Sans:wght@300;400;500;600;700;800&display=swap' rel='stylesheet' type='text/css'></link>
      <UserContextProvider apiUrl={pageProps.apiUrl}>
        <AuthorizedApolloProvider graphqlApi={pageProps.graphqlApi || publicRuntimeConfig.graphqlApi}>
          <Component {...pageProps} />
        </AuthorizedApolloProvider>
      </UserContextProvider>
    </SessionProvider>

  )
}

export default MyApp
